import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-179" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-180" data-mp="28ddhl9rhabqq">
        <p className="text-center font-mono text-[11px] font-bold uppercase tracking-[.2em] text-steel" data-id="element-181" data-mp="2d6zvt6dainon">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-balance text-center text-3xl font-extrabold uppercase text-ink sm:text-4xl" data-id="element-182" data-mp="2h7a26k4zvg41">
          Docentes de Automatización Industrial que ya cambiaron su forma de enseñar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-183" data-mp="2w4sntdmdld79">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-md border border-line bg-mist p-6" data-id="element-184" data-mp="wsghuprx0tsn" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-steel" data-id="element-185" data-mp="3dnd3jb3dc05w" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-186" data-mp="3dnwbbyzb1867">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-187" data-mp="38qcucrb82hak">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-petrolDark font-mono text-sm font-bold text-gold" data-id="element-188" data-mp="a6e701iqqjaj">
                  {initials}
                </span>
                <span data-id="element-189" data-mp="6x05grr5zcz">
                  <b className="block text-sm text-ink" data-id="element-190" data-mp="akvmlgrcvuc">{name}</b>
                  <small className="text-xs text-muted" data-id="element-191" data-mp="3sbzhp9h9elvj">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}